import { useContext, useMemo } from "react";
import { AppContext } from "../context/AppContext";

export const useReportDateRange = () => {
  const { selectedReportID, reports, selectedReportDetails } = useContext(AppContext);

  // Memoize the selected report to avoid unnecessary recalculations
  const selectedReport = useMemo(() => {
    return reports?.find((report) => report.id === selectedReportID);
  }, [reports, selectedReportID]);

  // Extract startDate and endDate from the selected report
  const startDate = selectedReportDetails?.start ?? selectedReport?.start ?? null;
  const endDate = selectedReportDetails?.end ?? selectedReport?.end ?? null;

  return { startDate, endDate };
};
